module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/RSS-af6b998d0dd5753a5fcf5e18fd12b826.svg";